import { HeaderCallButton, HeaderCallLink } from '@/app/components/Header';

import { VtLogo } from '../components/brand';

/** "(888) 888-0446" from any ten-digit number; anything else as given. */
export const displayPhone = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');
  return digits.length === 10 ? `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}` : phone;
};

/**
 * The chat's header: the Varsity Tutors logo and the page's (local) phone number, with the standard lead
 * form's own call link and button (app/components/Header.tsx): "We're Open! ● Call Now: (number)" from
 * 880px wide, a green "Call Now" button below. In the chat the logo isn't a link, so nobody leaves the
 * form; pages after it (the thank-you page) pass `homeHref`.
 */
export function ChatHeader({ phone, homeHref }: { phone: string; homeHref?: string }) {
  return (
    <>
      <a className="skip" href="#main">
        Skip to content
      </a>
      <header className="site-header is-chat" id="top">
        <div className="wrap hdr">
          {homeHref ? (
            <a className="lockup" href={homeHref} aria-label="Varsity Tutors home">
              <VtLogo />
            </a>
          ) : (
            <span className="lockup">
              <VtLogo />
            </span>
          )}
          <div className="hdr-call">
            <div className="hidden min-[880px]:flex items-center gap-2">
              <HeaderCallLink phoneNumber={phone} />
            </div>
            <div className="flex min-[880px]:hidden items-center">
              <HeaderCallButton phoneNumber={phone} />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
